import React, { Component } from 'react'
import { Modal } from 'antd'
import { aesEncrypt, createLoginMd5Key, http } from '@ud/admin-framework'
import SendMessage from './SendMessage'
import ResetPwd from './ResetPwd'
import './ResetPassword.less'
import {cryptoAes} from '../../../utils/cryptoAes'

class ResetPassword extends Component<IResetPasswordProps, IResetPasswordState> {

  constructor(props: IResetPasswordProps) {
    super(props)
    this.state = {
      verifyCode: '',
      changeForm: true,
      jobNumber: ''
    }
  }

  componentDidMount() {
    this.getVerifyCode()
  }

  render() {
    const { visiblestatus } = this.props
    const { verifyCode } = this.state
    const sendMsg = (
      <SendMessage verifyCode={verifyCode} changeImg={this.getVerifyCode} send={(data: any) => this.send(data)} />
    )
    const resetPassword = (
      <ResetPwd jobNumber={this.state.jobNumber} reset={(data: any) => this.reset(data)} />
    )

    return (
      <div className="reset-password">
        <Modal title="重置密码" visible={visiblestatus} destroyOnClose width={'450px'} onCancel={this.cancel} footer={false}>
          {this.state.changeForm ? sendMsg : resetPassword}
        </Modal>
      </div>
    )
  }

  private getVerifyCode = () => {
    http.get('/api/uaa/uaa/sso/ssoCode', {}).then(res => {
      this.setState({ verifyCode: res.data })
    })
  }

  private send = (data: any) => {
    this.setState({
      jobNumber: data.jobNumber
    })

    http.post('/api/uaa/manage/sso/findPassword', data).then((res) => {
      this.setState({ changeForm: false })
    }).catch(() => {
      this.getVerifyCode()
    })
  }

  private reset = (data: any) => {
    const params = {
      jobNumber: data.jobNumber,
      // password:  cryptoAes.encrypt(data.password, data.verificationCode),
      password:  aesEncrypt(data.password, createLoginMd5Key(data.verificationCode)),
      verificationCode: data.verificationCode
    }
    http.post('/api/uaa/manage/sso/updatePassword', params).then((res) => {
      this.cancel()
    })
  }

  private cancel = () => {
    this.getVerifyCode()
    this.props.cancel(false)
    this.setState({
      changeForm: true
    })
  }

}

interface IResetPasswordProps {
  visiblestatus: boolean
  cancel: any
}

interface IResetPasswordState {
  verifyCode: any
  jobNumber: string
  changeForm: boolean
}

export default ResetPassword
